import type { ApiClient, PendingBookingFinanceList } from '@elite-residence/api-client';
import { readResponse } from '../ui/ui';

// Counts and operational queues require every authorized page. A failed
// continuation never becomes a successful partial list.
export async function loadPendingFinance(client: ApiClient, signal?: AbortSignal) {
  const items: PendingBookingFinanceList['items'][number][] = [];
  const cursors = new Set<string>();
  let cursor: string | undefined;
  do {
    const response = await client.listPendingBookingFinance(
      { query: { limit: '500', ...(cursor ? { cursor } : {}) } },
      signal ? { signal } : {},
    );
    const page = readResponse(response);
    items.push(...page.items);
    cursor = page.nextCursor ?? undefined;
    if (cursor) {
      if (cursors.has(cursor)) throw new Error('pending_finance_cursor_repeated');
      cursors.add(cursor);
    }
  } while (cursor);
  return items;
}
